import React from 'react'
import styled from 'styled-components'
import Header from '../UI/Header'
import { menuItems, device } from '../../utils/helpers'
import Footer from '../UI/Footer'

const Wrapper = styled.div`
  min-height: 100%;
`

const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

const DefaultLayout = ({ children }) => (
  <Wrapper>
    <Header menuItems={menuItems} />
    <Content>
      {children}
    </Content>
    <Footer />
  </Wrapper>
)

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/components/Layout/Default.js